export const ImageOrderingAnalyticsMessages = {
  pageName: 'us foods:r4:image ordering',
  pageLoadedEvent: 'page loaded',
  startUploadEvent: 'start upload',
  finishProcessingEvent: 'finish processing',
  capability: 'ordering',
};
